import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, AlertCircle } from 'lucide-react';
import { api } from '../services/api';
export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState('');
  const [error, setError] = useState('');
  const [restaurant, setRestaurant] = useState(null);
  const [success, setSuccess] = useState('');

useEffect(() => {
  let tag = document.querySelector('meta[name="robots"]');

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'robots');
    document.head.appendChild(tag);
  }

  tag.setAttribute('content', 'noindex, nofollow');

  return () => {
    tag.setAttribute('content', 'index, follow');
  };
}, []);
  
  useEffect(() => {
  if (restaurant?.name) {
    document.title = `Forgot Password - ${restaurant.name}`;
  } else {
    document.title = 'Forgot Password';
  }
}, [restaurant]);

  useEffect(() => {
    api.getRestaurant().then(setRestaurant).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setWarning('');
    setError('');

    try {
      const res = await api.forgotPassword({ email });
      setSuccess(res.message || 'If that email exists, a reset link has been sent');
      setWarning('');
      setError('');
    } catch (err) {
      // ALWAYS show same message (no leaks)
      setSuccess('If that email exists, a reset link has been sent');
      setError('');
    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-lg mx-auto px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-xl">
            <ArrowLeft className="w-5 h-5 text-gray-700" />
          </button>
          <h1 className="text-lg font-bold text-gray-900">Forgot Password</h1>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-sm">

          {/* Logo */}
          <div className="text-center mb-8">
            {restaurant === null ? (
              <div className="w-20 h-20 mx-auto mb-3" />
            ) : restaurant?.logoUrl ? (
              <div className="w-20 h-20 mx-auto mb-3 flex items-center justify-center">
                <img src={restaurant.logoUrl} alt="" className="max-w-full max-h-full object-contain" />
              </div>
            ) : (
              <div className="w-16 h-16 bg-amber-700 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <span className="text-white font-bold text-2xl">
                  {restaurant?.name?.charAt(0)?.toUpperCase() || 'R'}
                </span>
              </div>
            )}

            <h2 className="text-2xl font-bold text-gray-900">{restaurant?.name || ''}</h2>
            <p className="text-gray-500 text-sm mt-1">
              Enter your email to receive a reset link
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-3">

            {success && (
            <div className="flex items-center gap-2 text-green-800 bg-green-50 border border-green-200 rounded-xl p-3">
                <AlertCircle className="w-4 h-4 text-green-600" />
                <p className="text-sm">{success}</p>
            </div>
            )}

            {warning && (
              <div className="flex items-center gap-2 text-amber-800 bg-amber-50 border border-amber-200 rounded-xl p-3">
                <AlertCircle className="w-4 h-4 text-amber-600" />
                <p className="text-sm">{warning}</p>
              </div>
            )}

            {error && (
              <div className="flex items-center gap-2 text-red-600 bg-red-50 border border-red-200 rounded-xl p-3">
                <AlertCircle className="w-4 h-4" />
                <p className="text-sm">{error}</p>
              </div>
            )}

            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full border border-gray-200 rounded-xl py-3 pl-11 pr-4 text-sm focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 bg-white"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gray-900 text-white py-3.5 rounded-xl font-semibold hover:bg-amber-700 transition-colors duration-200 disabled:opacity-60"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <button
            onClick={() => navigate('/login')}
            className="text-sm text-gray-500 mt-6 text-center w-full hover:text-gray-700"
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  );
}